import { Handler } from "../chain/TransformServiceHandlerChain";
import mimedb from "mime-db";
import { CustomApiTransformUtil } from "../util/CustomApiTransformUtil";
import { GenUtil } from "../../../../cutil/GenUtil";
import isBlank from "@sedan-utils/is-blank";
import { StoryNodeDisplayType } from "../../../../storyV2/domain/StoryNodeDisplayType";
import { CustomApiTransformError } from "../error/CustomApiTransformError";
export class BlobHandler extends Handler {
    constructor(brainClient) {
        super();
        this.brainClient = brainClient;
    }
    async process(request) {
        const displayType = request.displayType;
        /// 只处理 upload file type
        if (!CustomApiTransformUtil.isUploadFileType(displayType)) {
            return false;
        }
        const blob = await this.fetchBlob(request);
        if (!blob) {
            /// 如果是文件类型，但是不能回去文件类容
            throw CustomApiTransformError.default;
        }
        const data = new FormData();
        data.append("file", blob);
        const res = await this.brainClient.openAi.upload(data);
        const s3Url = res?.data?.object_s3_url || res?.data?.s3_https_url || "";
        const uuid = res?.data?.uuid;
        const { name, format } = this.generateFilename(request.contentType);
        const initCreateBlobUrl = {
            objectURL: URL.createObjectURL(blob),
            loading: false,
        };
        const textAreaValue = {
            loading: false,
            s3Url,
            s3Path: res?.data?.object_key,
            // TODO need to refactor
            needToCreateBlobUrl: `/api/me/upload/studios?url=${encodeURIComponent(s3Url)}`,
            uuid,
            name,
            format,
        };
        request.setResult({ initCreateBlobUrl, textAreaValue, displayType: displayType });
        return true;
    }
    generateFilename(contentType) {
        const types = contentType?.split(";") || [];
        let comfirmedType = undefined;
        for (const type of types) {
            for (const [key, _displayType] of CustomApiTransformUtil.mimeTypesMap) {
                const regex = new RegExp(`^${key}`);
                if (regex.test(type.trim())) {
                    comfirmedType = type;
                }
            }
        }
        const extensions = mimedb[comfirmedType || "text/html"].extensions;
        const fileExtension = Array.from(extensions || []).first() || "html";
        return { name: GenUtil.randomString() + "." + fileExtension, format: fileExtension };
    }
    async fetchBlob(request) {
        switch (request.displayType) {
            case StoryNodeDisplayType.UPLOADIMAGE:
            case StoryNodeDisplayType.AUDIO:
            case StoryNodeDisplayType.BASEVIDEO:
            case StoryNodeDisplayType.PDFFILE:
                return await request.blob();
            case StoryNodeDisplayType.HTML:
                if (!isBlank(request.websocketHtml)) {
                    return new Blob([request.websocketHtml], { type: "text/html" });
                }
        }
        return undefined;
    }
}
